import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5397c198&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5397c198&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5397c198",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5397c198')) {
      api.createRecord('5397c198', component.options)
    } else {
      api.reload('5397c198', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5397c198&scoped=true", function () {
      api.rerender('5397c198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Examination/index.vue"
export default component.exports